export const FETCH_REMOVAL_ITEM_ALL = "FETCH_REMOVAL_ITEM_ALL"
export const CREATE_REMOVAL_ITEM = "CREATE_REMOVAL_ITEM"
export const UPDATE_REMOVAL_ITEM = "UPDATE_REMOVAL_ITEM"
export const REMOVE_REMOVAL_ITEM = "REMOVE_REMOVAL_ITEM"
export const SELECT_REMOVAL_ITEM = "SELECT_REMOVAL_ITEM"

export const FETCH_REMOVAL_ITEMS_ALL = "FETCH_REMOVAL_ITEMS_ALL"
export const CREATE_REMOVAL_ITEMS = "CREATE_REMOVAL_ITEMS"
export const UPDATE_REMOVAL_ITEMS = "UPDATE_REMOVAL_ITEMS"
export const REMOVE_REMOVAL_ITEMS = "REMOVE_REMOVAL_ITEMS"